// extracted by mini-css-extract-plugin
module.exports = {"loader":"Root_loader__2ybmF","logo":"Root_logo__kZuYN"};